export default __webpack_public_path__ + "images/assets/e7e1c9da1331f657a69c2fb4a5b2ae8b.svg";